export default function Section() {
  return (
    <>
      <section id="g2" >

        <div className="pic1">
          <h1>Welcome Here</h1>
        </div>
        <div className="pic2">
          <p style={{
          }}>Dear Customer, if you are looking for a Delicious Food then you are on Perfect place.</p>
        </div>



      </section>

      <div className="container2">
        <div className="extra" ></div>
        <div className="g3">
          <h1>Best Seller</h1>
          <p style={{ textAlign: "center" }}>We Provide Quality Assurance to our Customers. Some of the Best Dishes in our Restaurants are Following </p>
        </div>
      </div>



      <div className="dishcontainer"  >
        <div className="dish1">
          <img src="./images/dish1.png" alt="" />
          <h3 style={{ paddingTop: '10px' }}>Fried Chicken</h3>
          <p style={{ textAlign: 'center' }}>Most Selling item of our Restaurant and have a Excellant Feedback</p>
        </div>
        <div className="dish2">
          <img src="./images/dish2.png" alt="" style={{
            height: '289px',
            paddingTop: '19px'
          }} />
          <h3 style={{ paddingTop: '10px' }} >Fried MeatBalls</h3>
          <p style={{ textAlign: 'center' }}>Most Selling item of our Restaurant and have a Excellant Feedback</p>

        </div>
        <div className="dish3">
          <img src="./images/dish3.png" alt="" style={{
            height: '289px',
            paddingTop: '19px'
          }} />
          <h3 style={{ paddingTop: '10px' }}>Pad Thai</h3>
          <p style={{ textAlign: 'center' }}>Most Selling item of our Restaurant and have a Excellant Feedback</p>

        </div>

      </div>


      <div className="group3">
        <div className="mid" >

          <div className="middd">
            <img src="./images/midpic.png" alt="" />
          </div>
          <div className="mid1" >
            <h2>Oriental Taste</h2>
            <p>Most Selling item of our Restaurant and have a Excellant Feedback. Hurry-up Order your Food</p>
            <button>ORDER NOW</button>
          </div>


        </div>
      </div>



      <div className="group4">
        <div className="g41">
          <h3>Statistics</h3>
          <p>Our Restaurant is Fully Maintained, Every task is Hold by a Seperate Person. Staff in Our Restaurant are Follows</p>
        </div>
        <div className="group42">
          <div className="g4">
            <h1>123</h1>
            <h3>OUTLETS</h3>
          </div>
          <div className="g4">
            <h1>100</h1>
            <h3>CHEF</h3>
          </div>
          <div className="g4">
            <h1>300</h1>
            <h3>MENU</h3>
          </div>
          <div className="g4">
            <h1>30</h1>
            <h3>COUNTRY</h3>
          </div>

        </div>
      </div>



      <div className="group5">
        <div className="g51">
          <h3>Chicken Grills</h3>
          <p>Most Selling item of our Restaurant and have a Excellant Feedback. Hurry-up Order your Food</p>
          <button>ORDER NOW</button>
        </div>

        <div className="g52">
          <img src="./images/dish2.png" alt="" />
        </div>
      </div>





      <div className="group6">
        <div className="g61">
          <p>A restaurant is a business that prepares and serves food and drinks to customers. Meals are generally served and eaten on the premises, but many restaurants also offer take-out and food delivery services.</p>
          <h3>Lenvora Fields</h3>
        </div>
      </div>



      <div className="group7">
        <div className="g71">
          <h3>Subscribe</h3>
          <p>Dear, If you are Satisfied by Our Restaurants then Don't Forget to Subscribe.</p>
        </div>
        <div className="g72">
          <form action="" method="post" netlify>
            <input type="text" placeholder="Your Email" style={{ float: "left", padding: '11px 30px' }} />
            <button >SUBSCRIBE</button>
          </form>
        </div>
      </div>



      <div className="group8">
        <div className="group88">
        <div className="g81">
          <h2>TITLE HERE</h2>
          <p>A restaurant is a business that prepares and serves food and drinks to customers. Meals are generally served and eaten on the premises, but many restaurants also offer take-out and food delivery services.</p>
          <div>
            <a href="/"><i class="fa-brands fa-instagram"></i></a>
            <a href="/"><i class="fa-brands fa-facebook"></i></a>
            <a href="/"><i class="fa-brands fa-twitter"></i></a>
            <a href="/"><i class="fa-brands fa-whatsapp"></i></a>
          </div>
        </div>
        <div className="g82">
          <h2>ABOUT</h2>
          <li>History</li>
          <li>Our Team</li>
          <li>Brand Guidlines</li>
          <li>Term & Conditions</li>
          <li>Privacy Policy</li>
        </div>

        <div className="g83">
          <h2>SERVICE</h2>
          <li>How To Order</li>
          <li>Our Product</li>
          <li>Order Status</li>
          <li>Promo</li>
          <li>Payment Method</li>
        </div>

        <div className="g84">
          <h2>OTHER</h2>
          <li>Contact us</li>
          <li>Help</li>
          <li>Privacy</li>
        </div>
        </div>
        <div><h6>All Right @2023 Reserved by<a href="https://its-malik.000webhostapp.com/"> <span>TawabMalikx</span></a></h6></div>
      </div>
      

    </>
  );
}